/**
 * @file query functions
 * @author tobias.frei@notch-interactive.com
 *
 * @module components/calendar/filter-query
 */

import model from './filter-model';

const instance = {};


/**
 * Gets called as soon as model.calendar.filtercloud changes. Uses a custom vue watcher.
 *
 * @return {void}
 */
instance.triggerCallFilter = () => {
    if (!document.body.classList.contains('body--noscroll')) {
        model.calendar.callFilter();
    }
};


/**
 * Create query from filtercloud
 *
 * @return {void}
 */
instance.callFilter = () => {
    let requestURL = model.settings.filterDataUrl;

    // Close all tiles
    model.calendar.closeAllTiles();


    // Add search parameter to requestURL if applicable
    if (model.calendar.stringsearch.length > 0) {
        requestURL += '&q=' + model.calendar.stringsearch;
    }

    // Add filter parameters to requestURL if applicable
    if (model.calendar.filtercloud.length > 0) {
        let filterPartials = [];

        model.calendar.filtercloud.forEach(function (cloudItem) {
            let filterPartial = cloudItem.filter + '|';

            // Time range subfilter
            if (cloudItem.filter === 'time' && cloudItem.sub) {
                filterPartial += cloudItem.key.replace('m', '') + '.' + cloudItem.parentkey;
            } else { // Other filter categories
                filterPartial += cloudItem.key;
            }

            filterPartials.push(filterPartial);
        });

        requestURL += '&filter=' + filterPartials.toString();
    }

    // Get new data from API
    model.calendar.fetchAjaxData(requestURL);
};


export default instance;
